export enum ApiError {
  GET_CLIENT_DATA_ERROR = "Не удалось получить данные опросника. Повторите попытку позже",
  GET_QUESTIONS_ERROR = "Не удалось получить данные о вопросах",
  SEND_LEAD_ERROR = "Не удалось отправить заявку. Повторите попытку позже",
  UPDATE_LEAD_ERROR = "Не удалось отправить данные. Сообщение их, когда наш оператор свяжется с вами",
  UNKNOWN_ERROR = "Неизвестная ошибка. Повторите попытку позже"
}